import React, { Component } from "react";
import MDEditor from "@uiw/react-md-editor";
import ImageUpload from "../content/ImageUpload";
import ImageOptions from "../content/ImageOptions";
import AwsConfig from "../../Config/AwsConfig";
import ListRegisteredCompanies from "../../Services/Queries/ListRegisteredCompanies";
import CompressContentImage from "../../Services/Mutations/compressContentImage";
import { Button, Modal } from "react-bootstrap";
import { heightPercentageToDP } from "../../Utils/ResponsiveScreen";
import MandatoryValidations from "../content/SubComponents/MandatoryValidations";

const styles = {
  input: {
    width: "190px",
  },
  mandatoryErrorText: {
    // fontSize: heightPercentageToDP('2'),
    color: "red",
  },
};

export default class CompanyDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      companyName: "",
      companyEmail: "",
      About: "",
      Address: "",
      Website: "",
      jobImages: [],
      selectedImage: "",
      mobileNumber: "",
      selectedGST: "",
      displayMobileNumberInJobPost: false,
      ImageObj: {},
      contactName: "",
      //contactEmail: '',
      suggestions: [],
      canEditCompany: false,
      companyDetails: {},
      selectedCompany: {},
      cropImage: false,
      croppedImage: "",
      src: null,
      crop: {
        unit: "%",
        width: 30,
        aspect: 16 / 9,
      },
      copyRight: false,
      copyRightText: "",
      shareImage: false,
      jobApplicationLink: "",
      mobileNumberValidation: false,
      markDownEditor: false,
    };
  }
  // componentDidUpdate = (prevProps, prevState) => {
  // 	console.log(this.props.companyDetails, 'this is the companyDetails in did update')
  // 	if (prevProps != this.props) {
  // 		console.log('inside condition')
  // 		let companydetails = this.props.companyDetails
  // 		this.setState({
  // 			companyDetails: companydetails,
  // 			// companyName: companydetails.companyName,
  // 			// About: companydetails.companyBio,
  // 			// jobImages: [{
  // 			// 	copyRight: false,
  // 			// 	copyRightText: "",
  // 			// 	imageValue: "",
  // 			// 	image: companydetails.companyLogo,
  // 			// 	shareImage: false,

  // 			// }],
  // 			// contactName: companydetails.contactName,
  // 			// companyEmail: companydetails.contactEmail,
  // 			//mobileNumber: '1234456678',
  // 			Address: companydetails.companyAddress ? companydetails.companyAddress : companydetails.companyRegisteredAddress,
  // 			// Website: companydetails.companyWebsite,

  // 		}, () => {
  // 			console.log(this.state.companyDetails, 'companyDetails n did update after edi')
  // 		})

  // 	}
  // }
  async componentDidMount() {
    if (
      this.props.jobDetailsAtEdit &&
      Object.keys(this.props.jobDetailsAtEdit).length > 0
    ) {
      this.updateStateData();
    }
    if (this.props.editCompany) {
      let editData = this.props.editCompany;
      this.setState({
        companyDetails: editData,
        companyName: editData.companyName,
        PK: editData.PK,
        SK: editData.SK,
        companyEmail: editData.companyEmail,
        About: editData.companyBio,
        Address: editData.companyAddress,
        jobImages: editData.companyLogo
          ? [
              {
                copyRight: false,
                copyRightText: "",
                imageValue: "",
                image: editData.companyLogo,
                shareImage: false,
              },
            ]
          : [],
        Website: editData.companyWebsite,
        contactName: editData.contactName,
        // selectedImage: editData.selectedImage,
        // mobileNumber: editData.phoneNumber.split('+91')[0],
        mobileNumber: editData.phoneNumber,
        selectedGST: editData.GST,
        jobApplicationLink: editData.jobApplicationLink,
        // displayMobileNumberInJobPost: editData.displayMobileNumberInJobPost,
        // suggestions: editData.suggestions,
        // selectedCompany: editData.selectedCompany,
        // companyDetails: editData.companyDetails,
        // jobImages: editData.companyLogo,
      });
    }
  }
  updateStateData = () => {
    const {
      contactName,
      contactEmail,
      contactMobileNumber,
      companyName,
      companyBio,
      GST,
      companyRegisteredAddress,
      displayMobileNumberInJobPost,
      companyWebsite,
      jobImages,
      jobApplicationLink,
    } = this.props.jobDetailsAtEdit;
    this.setState({
      companyDetails: this.props.jobDetailsAtEdit,
      companyName: companyName,
      companyEmail: contactEmail,
      About: companyBio,
      selectedGST: GST,
      Address: companyRegisteredAddress,
      contactName: contactName,
      displayMobileNumberInJobPost: displayMobileNumberInJobPost,
      Website: companyWebsite,
      jobImages:
        jobImages && jobImages[0] && jobImages[0].image != null
          ? jobImages
          : [],
      mobileNumber: contactMobileNumber,
      selectedImage: jobImages?.length > 0 ? jobImages[0].image : "",
      jobApplicationLink: jobApplicationLink && jobApplicationLink,
    });
  };
  createCompanyValidations = (text) => {
    const SpaceValidation = text.includes(" ") && text.length <= 3;
    const EnterValidation = text.includes("\n") && text.length <= 3;
    const isEnglishChar = text.match(/^[a-zA-Z]*$/);
    const SpecialChar = isEnglishChar ? text.match(/[^\w\s]/gi) : false;
    const spaceEnterValidation = !SpaceValidation && !EnterValidation;
    const createCompany = spaceEnterValidation && !SpecialChar;
    return createCompany;
  };

  handleOnChangeCompanyName = async (text) => {
    this.setState({ companyName: text });
    const createCompany = this.createCompanyValidations(text);
    if (createCompany) {
      if (text.length >= 3) {
        const addCompanyToSuggestions = {
          companyName: text,
          isNewCompany: true,
        };
        const input = {
          search: text,
        };
        const suggestedCompanies = await ListRegisteredCompanies(input);
        const isCompanyAvailable =
          suggestedCompanies.items &&
          suggestedCompanies.items.filter((item) => {
            if (item.companyName.toLowerCase() == text.toLowerCase()) {
              return true;
            }
          });
        if (isCompanyAvailable.length == 0) {
          suggestedCompanies.items.splice(0, 0, addCompanyToSuggestions);
        }
        this.setState({ suggestions: suggestedCompanies });
      } else {
        // this.setState({ suggestions: [] })
      }
    }
  };

  handleSuggestionClick = (suggestion) => {
    let details = this.state.companyDetails;
    if (suggestion.isNewCompany) {
      details["companyName"] = suggestion.companyName;

      this.setState({
        companyName: suggestion.companyName,
        companyDetails: details,
        selectedCompany: suggestion,
        suggestions: [],
      });
    } else {
      details = suggestion;
      this.setState({
        companyDetails: details,
        selectedCompany: details,
        suggestions: [],
        companyName: suggestion.companyName,
        companyEmail: suggestion.companyEmail,
        About: suggestion.companyBio,
        Address: suggestion.companyAddress,
        Website: suggestion.companyWebsite,
        jobImages: suggestion.companyLogo
          ? [
              {
                imageValue: this.state.src,
                image: suggestion.companyLogo,
                copyRight: false,
                copyRightText: "",
                shareImage: false,
              },
            ]
          : [],
        mobileNumber: suggestion.phoneNumber,
        jobApplicationLink: suggestion.jobApplicationLink,
        contactName: suggestion.contactName,
        selectedGST: suggestion.GST ? suggestion.GST : "",
        displayMobileNumberInJobPost: suggestion.displayMobileNumberInJobPost,
      });
    }
    this.props.registerCompany(suggestion.isNewCompany, details);
    // this.props.updateInParent(`workType`, this.state.selectedWorkType, 'Job')
  };
  openModal = (details, suggestion) => {
    return (
      <Modal
        show={this.state.companyModalVisible}
        onHide={() => this.handleModal()}
      >
        <Modal.Body>All The Company Details Will Be Discarded</Modal.Body>
        <Modal.Footer>
          <Button onClick={() => this.closeModal(details, suggestion)}>
            Ok
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };
  handleModal = () => {
    this.setState({ companyModalVisible: !this.state.companyModalVisible });
  };
  closeModal = (details, suggestion) => {
    if (suggestion.isNewCompany) {
      details["companyName"] = suggestion.companyName;

      this.setState({
        companyName: suggestion.companyName,
        companyDetails: details,
        selectedCompany: suggestion,
        suggestions: [],
        companyModalVisible: !this.state.companyModalVisible,
      });
    } else {
      details = suggestion;
      this.setState({
        companyDetails: details,
        selectedCompany: details,
        suggestions: [],
        companyName: suggestion.companyName,
        companyEmail: suggestion.companyEmail,
        About: suggestion.companyBio,
        Address: suggestion.companyAddress,
        Website: suggestion.companyWebsite,
        jobImages: suggestion.companyLogo
          ? [
              {
                imageValue: this.state.src,
                key: suggestion.companyLogo,
                copyRight: false,
                copyRightText: "",
                shareImage: false,
              },
            ]
          : [],
        contactName: suggestion.contactName,
        GST: suggestion.GST,
        jobApplicationLink: suggestion.jobApplicationLink,
        mobileNumber: suggestion.phoneNumber.includes("+91")
          ? suggestion.phoneNumber.split("+91")[1]
          : suggestion.phoneNumber,
        displayMobileNumberInJobPost: suggestion.displayMobileNumberInJobPost,
        companyModalVisible: !this.state.companyModalVisible,
      });
    }

    this.props.registerCompany(suggestion.isNewCompany, details);
  };
  handleOnChangeCompanyName2 = async (text) => {
    const { selectedCompany } = this.state;
    let details = this.state.companyDetails;

    details["companyName"] = text;
    this.setState({ companyName: text, companyDetails: details });
    this.props.registerCompany(selectedCompany.isNewCompany, details);
  };
  hasCompanyNameError = () => {
    return !this.state.companyName;
  };
  handleAboutCompany = (text) => {
    const { selectedCompany } = this.state;
    let details = this.state.companyDetails;
    details["companyBio"] = text;
    this.setState({ About: text, companyDetails: details });
    this.props.registerCompany(selectedCompany.isNewCompany, details);
  };
  hasCompanyAboutError = () => {
    return !this.state.About;
  };
  handleCompanyAddress = (text) => {
    const { selectedCompany } = this.state;
    let details = { ...this.state.companyDetails };
    // if (this.props.editContent) {
    details["companyRegisteredAddress"] = text;

    // } else {
    details["companyAddress"] = text;
    // }
    this.setState({ Address: text, companyDetails: details });

    this.props.registerCompany(selectedCompany.isNewCompany, details);
  };
  hasCompanyAddressError = () => {
    return !this.state.Address;
  };
  setGSTNNumber = (value) => {
    const { selectedCompany } = this.state;

    let details = this.state.companyDetails;
    details["GST"] = value;
    this.setState({ selectedGST: value, companyDetails: details });
    this.props.registerCompany(selectedCompany.isNewCompany, details);
    // if (!this.props.createMode) {
    // 	this.props.updateInParent('GST', jobLink, 'Job')
    // }
  };
  handleJobApplicationLink = (value) => {
    const jobLink = value ? value.trim() : value;
    const { selectedCompany } = this.state;
    let details = this.state.companyDetails;
    details["jobApplicationLink"] = jobLink;

    this.setState({ jobApplicationLink: jobLink, companyDetails: details });
    this.props.registerCompany(selectedCompany.isNewCompany, details);

    if (!this.props.createMode) {
      this.props.updateInParent("jobApplicationLink", jobLink, "Job");
    }
  };
  contactValidations = () => {
    const { companyEmail, jobApplicationLink, mobileNumber } = this.state;
    var contactValidation;
    if (!this.props.createMode) {
      contactValidation =
        companyEmail == "" && jobApplicationLink == "" && mobileNumber == ""
          ? true
          : false;
    } else {
      contactValidation =
        companyEmail == "" && mobileNumber == "" ? true : false;
    }
    return contactValidation;
  };
  checkEmail = () => {
    const { companyEmail } = this.state;
    const emailError =
      companyEmail.includes("@") && companyEmail.includes(".") ? false : true;
    return emailError;
  };
  handleReadMoreLink = (e) => {
    const { selectedCompany } = this.state;
    const readMoreLink = e.target.value
      ? e.target.value.trim()
      : e.target.value;
    let details = this.state.companyDetails;
    details["companyWebsite"] = readMoreLink;
    this.setState({ Website: readMoreLink, companyDetails: details });
    this.props.registerCompany(selectedCompany.isNewCompany, details);
  };
  pushImageObj = async (imageObj, selectedImages) => {
    let { jobImages } = this.state;
    let images = jobImages ? jobImages : [];
    images.push(imageObj);
    const input = {
      imagePath: imageObj.key,
    };
    console.log(input, "===========compressImageinput");

    this.handleJobImages(images);
    if (
      input != undefined &&
      input != null &&
      input.imagePath != null &&
      input.imagePath != undefined &&
      input.imagePath != ""
    ) {
      const response = await CompressContentImage(input);
      console.log(response, "response compress image ==========");
    }
  };
  handleJobImages = (images) => {
    const imagesArr = [];
    const { selectedCompany } = this.state;
    let details = this.state.companyDetails;
    images.filter((item) => {
      const obj = {
        image: item.key ? item.key : item.image,
        copyRight: item.copyRight,
        copyRightText: item.copyRightText,
        shareImage: item.shareImage,
      };
      imagesArr.push(obj);
    });
    details["companyLogo"] = images.length > 0 ? images[0].key : "";

    this.setState({ jobImages: images, companyDetails: details });
    this.props.registerCompany(selectedCompany.isNewCompany, details);
    if (!this.props.createMode) {
      this.props.updateInParent("jobImages", imagesArr, "Job");
    }
  };
  removeImage = (imageIndex) => {
    const images = this.state.jobImages;
    images.splice(imageIndex, 1);
    this.handleJobImages(images);
  };
  toggleCopyRightSwitch = (key) => {
    const { jobImages } = this.state;
    jobImages.filter((item) => {
      if (item.key == key) {
        item.copyRight = !item.copyRight;
      }
    });
    this.handleJobImages(jobImages);
  };
  handleCopyrightType = (item, copyrightPrefix) => {
    const key = item.key ? item.key : item.image;

    const { jobImages } = this.state;
    jobImages.filter((item) => {
      const property = item.key ? "key" : "image";
      if (item[property] == key) {
        item.copyRightText = copyrightPrefix;
      }
    });
    this.handleJobImages(jobImages);
  };
  handleCopyrightText = (key, text) => {
    const { jobImages } = this.state;
    jobImages.filter((item) => {
      const property = item.key ? "key" : "image";
      if (item[property] == key) {
        item.copyRightText = text;
      }
    });
    this.handleJobImages(jobImages);
  };
  toggleShareImageSwitch = (item) => {
    const key = item.key ? item.key : item.image;
    const { jobImages } = this.state;
    jobImages.filter((item) => {
      const property = item.key ? "key" : "image";
      if (item[property] == key) {
        item.shareImage = !item.shareImage;
      }
    });
    this.handleJobImages(jobImages);
  };
  handleContactName = (value) => {
    const { selectedCompany } = this.state;
    let details = this.state.companyDetails;
    details["contactName"] = value;

    this.setState({ contactName: value, companyDetails: details });
    this.props.registerCompany(selectedCompany.isNewCompany, details);
    if (!this.props.createMode) {
      this.props.updateInParent("contactName", value, "Job");
    }
  };
  handleCompanyEmail = (value) => {
    const { selectedCompany } = this.state;
    let details = this.state.companyDetails;
    details["companyEmail"] = value;
    this.setState({ companyEmail: value, companyDetails: details });
    this.props.registerCompany(selectedCompany.isNewCompany, details);
  };
  handleMobileNumber = (value) => {
    const { selectedCompany, displayMobileNumberInJobPost } = this.state;
    let details = this.state.companyDetails;
    details["phoneNumber"] = value;
    details["displayMobileNumberInJobPost"] = value.length == 10 ? true : false;
    this.setState({
      mobileNumber: value,
      displayMobileNumberInJobPost: details.displayMobileNumberInJobPost,
      companyDetails: details,
      mobileNumberValidation: true,
    });
    this.props.registerCompany(selectedCompany.isNewCompany, details);
  };
  handleDispMobileNumber = () => {
    const { selectedCompany, displayMobileNumberInJobPost } = this.state;
    let details = this.state.companyDetails;
    details["displayMobileNumberInJobPost"] = !displayMobileNumberInJobPost;
    this.setState({
      displayMobileNumberInJobPost: !displayMobileNumberInJobPost,
      companyDetails: details,
    });
    this.props.registerCompany(selectedCompany.isNewCompany, details);
  };

  hasMobileNumberError = () => {
    const { selectedCompany, displayMobileNumberInJobPost } = this.state;
    const mobileNumber = this.state.mobileNumber.includes("+91")
      ? this.state.mobileNumber.split("+91")[1]
      : this.state.mobileNumber;
    const error = mobileNumber.length === 10 ? false : true;
    if (error) {
      let details = this.state.companyDetails;
      details["displayMobileNumberInJobPost"] = !displayMobileNumberInJobPost;
      this.setState({
        displayMobileNumberInJobPost: !displayMobileNumberInJobPost,
        companyDetails: details,
      });
      this.props.registerCompany(selectedCompany.isNewCompany, details);
    }
    return error;
  };
  render() {
    const {
      companyName,
      companyEmail,
      About,
      Address,
      Website,
      selectedImage,
      mobileNumber,
      displayMobileNumberInJobPost,
      suggestions,
      selectedCompany,
      companyDetails,
      jobImages,
    } = this.state;
    const finalmobileNumber =
      this.state.mobileNumber && this.state.mobileNumber.includes("+91")
        ? this.state.mobileNumber.split("+91")[1]
        : this.state.mobileNumber;
    return (
      <div class="row col-md-14">
        {!this.props.createMode ? (
          <details>
            <summary>Company Details</summary>
            <div class="row">
              <text for="text">Name :</text>
              <div class="row1">
                <input
                  type="text"
                  onChange={(e) => {
                    this.handleOnChangeCompanyName(e.target.value);
                  }}
                  value={companyName}
                  placeholder="Please Enter  Name"
                ></input>
                {suggestions && suggestions.items
                  ? suggestions.items.map((item, index) => (
                      <div
                        key={index}
                        onClick={() => this.handleSuggestionClick(item)}
                      >
                        <text>{item.companyName}</text>
                      </div>
                    ))
                  : null}
              </div>
            </div>
            <div class="row">
              <text for="text">About :</text>
              <MDEditor
                preview={this.state.markDownEditor ? "live" : "edit"}
                value={About}
                onChange={(value) => this.handleAboutCompany(value)}
              />
            </div>
            <div class="row">
              <text for="text">Company Logo :</text>
              <div className="App">
                <ImageUpload
                  pushImageObj={this.pushImageObj}
                  multiImages={true}
                />
                {/* {jobImages.length > 0 ? null : (
                                <text for='text' style={{ color: 'red', fontSize: 10 }}>
                                    Please upload an image
                                </text>
                            )} */}
                {jobImages?.map((item, index) => {
                  const {
                    copyRightText,
                    copyRight,
                    shareImage,
                    imageValue,
                    image,
                  } = item;
                  const cdnurl = AwsConfig.cdn_url;
                  let finalImage = image ? image : "";
                  if (finalImage && !finalImage.includes(cdnurl)) {
                    finalImage = cdnurl + image;
                  }
                  // const key = item.key ? item.key : item.image
                  const srcImg = image ? finalImage : imageValue;
                  return (
                    <div className="imagesContainer">
                      <img style={{ maxWidth: "100%" }} src={srcImg} />
                      <button onClick={() => this.removeImage(index)}>
                        Remove Image
                      </button>
                      <div className="imgPreview">
                        <ImageOptions
                          syncToWordpress={this.state.syncToWordpress}
                          item={item}
                          copyRight={copyRight}
                          copyRightText={copyRightText}
                          toggleCopyRightSwitch={(item) =>
                            this.toggleCopyRightSwitch(item)
                          }
                          handleCopyrightType={(item, copyrightPrefix) =>
                            this.handleCopyrightType(item, copyrightPrefix)
                          }
                          handleCopyrightText={this.handleCopyrightText}
                          shareImage={shareImage}
                          toggleShareImageSwitch={(item) =>
                            this.toggleShareImageSwitch(item)
                          }
                        />
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div class="row" style={{ marginBottom: 5 }}>
              <text>Contact Person : </text>
              <textarea
                style={styles.input}
                type="text"
                onChange={(e) => {
                  this.handleContactName(e.target.value);
                }}
                value={this.state.contactName}
                placeholder="Please Enter contact Name"
              ></textarea>
            </div>
            <div class="row" style={{ marginBottom: 5 }}>
              <text>Contact Email : </text>
              <input
                style={styles.input}
                type="text"
                onChange={(e) => {
                  this.handleCompanyEmail(e.target.value);
                }}
                value={this.state.companyEmail}
                placeholder="Please Enter contact Email"
              ></input>

              {this.state.companyEmail && this.checkEmail() ? (
                <text for="text" style={{ color: "red", fontSize: 10 }}>
                  Please Enter Valid Email
                </text>
              ) : null}
            </div>
            <div class="row">
              <div class="col-md-6">
                <text htmlFor="userName"> Mobile Number</text>
                <div className="input-group ">
                  <div className="input-group-prepend">
                    <span className="input-group-text">+91</span>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    value={finalmobileNumber}
                    placeholder="Enter Mobile Number"
                    onChange={(e) => this.handleMobileNumber(e.target.value)}
                  />
                </div>
                {finalmobileNumber && finalmobileNumber.length != 10 ? (
                  <text for="text" style={{ color: "red", fontSize: 10 }}>
                    Mobile Number Should Be 10 digits
                  </text>
                ) : null}
              </div>

              <div
                class="col-md-12"
                style={{ marginTop: 5, marginBottom: 5, marginLeft: -5 }}
              >
                <input
                  type="checkbox"
                  onChange={this.handleDispMobileNumber}
                  checked={this.state.displayMobileNumberInJobPost}
                  style={{ marginRight: 5, marginLeft: 0 }}
                ></input>
                <text for="text">
                  Candidate Can Directly Call To This Number
                </text>
              </div>
            </div>
            <div class="row">
              <text for="text">Job Application Link :</text>
              <input
                type="text"
                onChange={(e) => {
                  this.handleJobApplicationLink(e.target.value);
                }}
                value={this.state.jobApplicationLink}
                placeholder="Please Enter  Job Application Link"
              ></input>
            </div>
            {this.contactValidations() ? (
              <text style={styles.mandatoryErrorText}>
                {"Please fill Contact Information"}
              </text>
            ) : null}

            <div class="row">
              <text for="text">Website :</text>
              <input
                type="text"
                onChange={(value) => {
                  this.handleReadMoreLink(value);
                }}
                value={Website}
                placeholder="Please Enter  Website Link"
              ></input>
            </div>
            <div class="row" style={{ marginBottom: 5, display: "inline" }}>
              <text>GSTN : </text>
              <input
                style={styles.input}
                type="text"
                onChange={(e) => this.setGSTNNumber(e.target.value)}
                value={this.state.selectedGST}
                // placeholder='Choose Category'
              ></input>
            </div>
            <div class="row">
              <text for="text">Address :</text>
              <MDEditor
                preview={this.state.markDownEditor ? "live" : "edit"}
                value={Address}
                onChange={(value) => this.handleCompanyAddress(value)}
              />
            </div>
          </details>
        ) : (
          <div>
            <text>
              <b>Company Details</b>
            </text>
            <div class="row">
              <text for="text">
                <b>Name :</b>
              </text>
              <div class="row1">
                <input
                  type="text"
                  onChange={(e) => {
                    this.handleOnChangeCompanyName2(e.target.value);
                  }}
                  value={companyName}
                  placeholder="Please Enter  Name"
                ></input>

                {suggestions && suggestions.items
                  ? suggestions.items.map((item, index) => (
                      <div
                        key={index}
                        onClick={() => this.handleSuggestionClick(item)}
                      >
                        <text>{item.companyName}</text>
                      </div>
                    ))
                  : null}
              </div>
              <div>
                {this.hasCompanyNameError() ? (
                  <text for="text" style={{ color: "red", fontSize: 10 }}>
                    Name Cannot Be Empty
                  </text>
                ) : null}
              </div>
            </div>
            <div class="row">
              <text for="text">
                <b>About :</b>
              </text>
              <MDEditor
                preview={this.state.markDownEditor ? "live" : "edit"}
                value={About}
                onChange={(value) => this.handleAboutCompany(value)}
              />
            </div>
            <div>
              {this.hasCompanyAboutError() ? (
                <text for="text" style={{ color: "red", fontSize: 10 }}>
                  About Cannot Be Empty
                </text>
              ) : null}
            </div>
            <div class="row">
              <text for="text">
                <b>Company Logo :</b>
              </text>
              <div className="App">
                <ImageUpload
                  pushImageObj={this.pushImageObj}
                  multiImages={true}
                />
                {/* {jobImages.length > 0 ? null : (
                                <text for='text' style={{ color: 'red', fontSize: 10 }}>
                                    Please upload an image
                                </text>
                            )} */}
                {jobImages?.map((item, index) => {
                  const {
                    copyRightText,
                    copyRight,
                    shareImage,
                    imageValue,
                    image,
                  } = item;
                  const cdnurl = AwsConfig.cdn_url;

                  let finalImage = image ? image : "";

                  if (finalImage && !finalImage.includes(cdnurl)) {
                    finalImage = cdnurl + image;
                  }
                  // const key = item.key ? item.key : item.image
                  const srcImg = image ? finalImage : imageValue;
                  return (
                    <div className="imagesContainer">
                      <img style={{ maxWidth: "100%" }} src={srcImg} />
                      <button onClick={() => this.removeImage(index)}>
                        Remove Image
                      </button>
                      <div className="imgPreview">
                        <ImageOptions
                          syncToWordpress={this.state.syncToWordpress}
                          item={item}
                          copyRight={copyRight}
                          copyRightText={copyRightText}
                          toggleCopyRightSwitch={(item) =>
                            this.toggleCopyRightSwitch(item)
                          }
                          handleCopyrightType={(item, copyrightPrefix) =>
                            this.handleCopyrightType(item, copyrightPrefix)
                          }
                          handleCopyrightText={this.handleCopyrightText}
                          shareImage={shareImage}
                          toggleShareImageSwitch={(item) =>
                            this.toggleShareImageSwitch(item)
                          }
                        />
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div class="row" style={{ marginBottom: 5 }}>
              <text>
                <b>Contact Person :</b>
              </text>
              <textarea
                style={styles.input}
                type="text"
                onChange={(e) => {
                  this.handleContactName(e.target.value);
                }}
                value={this.state.contactName}
                placeholder="Please Enter contact Name"
              ></textarea>
            </div>
            <div class="row" style={{ marginBottom: 5 }}>
              <text>
                <b>Contact Email : </b>
              </text>
              <input
                style={styles.input}
                type="text"
                onChange={(e) => {
                  this.handleCompanyEmail(e.target.value);
                }}
                value={this.state.companyEmail}
                placeholder="Please Enter contact Email"
              ></input>

              {this.state.companyEmail && this.checkEmail() ? (
                <text for="text" style={{ color: "red", fontSize: 10 }}>
                  Please Enter Valid Email
                </text>
              ) : null}
            </div>
            <div class="row">
              <div class="col-md-6">
                <text htmlFor="userName">
                  <b>Mobile Number</b>{" "}
                </text>
                <div className="input-group ">
                  <div className="input-group-prepend">
                    <span className="input-group-text">+91</span>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    value={this.state.mobileNumber}
                    placeholder="Enter Mobile Number"
                    onChange={(e) => this.handleMobileNumber(e.target.value)}
                  />
                </div>
                {this.state.mobileNumber &&
                this.state.mobileNumber.length != 10 ? (
                  <text for="text" style={{ color: "red", fontSize: 10 }}>
                    Mobile Number Should Be 10 digits
                  </text>
                ) : null}
              </div>

              <div
                class="col-md-12"
                style={{ marginTop: 5, marginBottom: 5, marginLeft: -5 }}
              >
                <input
                  type="checkbox"
                  onChange={this.handleDispMobileNumber}
                  checked={this.state.displayMobileNumberInJobPost}
                  style={{ marginRight: 5, marginLeft: 0 }}
                ></input>
                <text for="text">
                  Candidate Can Directly Call To This Number
                </text>
              </div>
            </div>
            <div class="row">
              <text for="text">Job Application Link :</text>
              <input
                type="text"
                onChange={(e) => {
                  this.handleJobApplicationLink(e.target.value);
                }}
                value={this.state.jobApplicationLink}
                placeholder="Please Enter  Job Application Link"
              ></input>
            </div>
            {this.contactValidations() ? (
              <text style={styles.mandatoryErrorText}>
                {"Please fill Contact Information"}
              </text>
            ) : null}

            <div class="row">
              <text for="text">
                <b>Website :</b>
              </text>
              <input
                type="text"
                onChange={(value) => {
                  this.handleReadMoreLink(value);
                }}
                value={Website}
                placeholder="Please Enter  Website Link"
              ></input>
            </div>
            <div class="row" style={{ marginBottom: 5, display: "inline" }}>
              <text>
                <b>GSTN : </b>
              </text>
              <input
                style={styles.input}
                type="text"
                onChange={(e) => this.setGSTNNumber(e.target.value)}
                value={this.state.selectedGST}
                // placeholder='Choose Category'
              ></input>
            </div>
            <div class="row">
              <text for="text">
                <b>Address :</b>
              </text>
              <MDEditor
                preview={this.state.markDownEditor ? "live" : "edit"}
                value={Address}
                onChange={(value) => this.handleCompanyAddress(value)}
              />
            </div>
            {/* <div>
									{this.hasCompanyAddressError() ? (
										<text for='text' style={{ color: 'red', fontSize: 10 }}>
											address Cannot Be Empty
										</text>
									) : null}
								</div> */}
          </div>
        )}
        {this.props.mandatoryFieldsData &&
        Object.keys(this.props.mandatoryFieldsData).length > 0 ? (
          <>
            <MandatoryValidations
              totalContentMissingFields={this.props.mandatoryFieldsData}
            />
          </>
        ) : null}
      </div>
    );
  }
}
